export enum HeaderMenuActionNames {
  NEW_VERSION = 'new-version',
}

class HeaderMenuActions {
  private $rootScope: any;

  public setup($rootScope: any): void {
    this.$rootScope = $rootScope;
  }

  public handleReloadVenueAction = (): void => {
    this.$rootScope.$broadcast(HeaderMenuActionNames.NEW_VERSION);
  }
}

const instance = new HeaderMenuActions();
export default instance as HeaderMenuActions;
